import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance.js";

export const fetchFavoriteStudents = createAsyncThunk(
  "teacherFavorites/fetch",
  async (_, thunkAPI) => {
    try {
      const res = await axiosInstance.get("/teacher/favorites");
      return res.data;
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      return thunkAPI.rejectWithValue(
        "Не удалось загрузить избранных учеников"
      );
    }
  }
);

export const addFavoriteStudent = createAsyncThunk(
  "teacherFavorites/add",
  async (student, thunkAPI) => {
    try {
      await axiosInstance.post(`/teacher/favorites/${student.id}`);

      return student; // student = { id, name, avatar, ... }
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      return thunkAPI.rejectWithValue("Ошибка при добавлении");
    }
  }
);

export const removeFavoriteStudent = createAsyncThunk(
  "teacherFavorites/remove",
  async (studentId, thunkAPI) => {
    try {
      await axiosInstance.delete(`/teacher/favorites/${studentId}`);

      return studentId;
      // eslint-disable-next-line no-unused-vars
    } catch (err) {
      return thunkAPI.rejectWithValue("Ошибка при удалении");
    }
  }
);
